import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { FloatingActionButton } from '../../../components/Button'
import { journalPageItems, useGetJournals } from '@zendia/frontend-shared'
import { AddTwo } from '@nine-thirty-five/material-symbols-react/rounded'
import { axiosRequest } from '../../../utilities/axiosClient'
import { JournalContainer } from '../../../components/Journal'
import { ActionBar } from '../../../components/ActionBar'
import { useLoadMoreOnScroll } from '../../../hooks/useLoadMoreOnScroll'

export const Route = createFileRoute('/_authenticated/journal/')({
  component: JournalPage,
})

function JournalPage() {
  const navigate = useNavigate()
  const { data, isLoading, error, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useGetJournals(axiosRequest)
  const sentinelRef = useLoadMoreOnScroll({
    hasNextPage: !!hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  })

  const onEntryFABClick = () => {
    navigate({
      to: 'new/form',
      // params: { entryId: 'new' },
      from: '/journal/',
    })
  }

  return (
    <>
      <ActionBar title="Journal" />
      <div className="flex flex-col p-4">
        <>
          {isLoading && <div>Loading...</div>}
          {error && <div>Error loading journal entries</div>}
          {!isLoading && data && <JournalContainer items={journalPageItems(data)} />}
          <div ref={sentinelRef} />
          {isFetchingNextPage && <div className="py-4 text-center">Loading more...</div>}
        </>
        <FloatingActionButton
          onClick={onEntryFABClick}
          className="bottom-22 sm:bottom-10 right-4 sm:right-10"
        >
          <AddTwo />
        </FloatingActionButton>
      </div>
    </>
  )
}
